<article class="individualUniversityDetailView">
  @if (!isDean) {
    <section class="universityAndTotal">
      <section class="allActiveUniversitiesDetails">
        <p class="arrow-container">
          <mat-icon class="leftArrow" (click)="onBack()">chevron_left</mat-icon>
        </p>
        <h2 (click)="onBack()" class="individualUniversityName">
          {{ universityToViewIndividually?.universityName }} ({{ yearOfStudy }})
        </h2>
      </section>
      <p class="universityTotal">
        {{
          universityToViewIndividually?.universityTotalAllocated || 0
            | customCurrency
        }}
      </p>
    </section>
  }

  @if (isDean) {
    <section class="total-fund-container">
      <p>Total fund allocation:</p>
      <p class="universityTotal">
        {{
          (activeUniversitiesFundAllocationsData &&
          activeUniversitiesFundAllocationsData.length > 0
            ? activeUniversitiesFundAllocationsData[0].universityTotalAllocated
            : 0
          ) | customCurrency
        }}
      </p>
    </section>
  }

  <mat-divider class="matDivider"></mat-divider>
  @for (
    universityDepartment of universityToViewDepartments;
    track universityDepartment
  ) {
    <section class="department-total">
      <p class="individualUniversityDepartmentName">
        {{ universityDepartment.departmentName }}
      </p>
      <p class="departmentTotal">
        {{
          checkDecimals(universityDepartment.departmentTotalAllocationAmount)
            | customCurrency
        }}
      </p>
    </section>
    <mat-divider class="matDivider"></mat-divider>
    <app-allocation-usage
      [departmentAllocationsInfo]="universityDepartment"
      class="allocationUsage"
    >
    </app-allocation-usage>
  }
</article>
